import {
  hexToRGB,
  MOON_600,
  TEAL_300,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
import {IconLightbulbInfo} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Panel = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
Panel.displayName = 'S.Panel';

export const Circle = styled.div`
  border-radius: 50%;
  width: 96px;
  height: 96px;
  background-color: ${hexToRGB(TEAL_300, 0.48)};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;
  margin-bottom: 16px;
`;
Circle.displayName = 'S.Circle';

export const LightBulb = styled(IconLightbulbInfo)`
  width: 36px;
  height: 48px;
  color: ${TEAL_600};
`;
LightBulb.displayName = 'S.LightBulb';

export const Heading = styled.div`
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 8px;
`;
Heading.displayName = 'S.Heading';

export const Message = styled.div`
  text-align: center;
  max-width: 600px;
  font-size: 16px;
  line-height: 25px;
  margin-bottom: 16px;
`;
Message.displayName = 'S.Message';

export const Mailto = styled.a`
  color: ${TEAL_600};
`;
Mailto.displayName = 'S.Mailto';

export const MessageSmall = styled.div`
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: ${MOON_600};
`;
MessageSmall.displayName = 'S.MessageSmall';
